
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  Grid,
  Stack,
  Typography,
  Box,
  Button,
  Modal,
  Divider,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Tab,

  CircularProgress
} from '@mui/material';

import { Icon } from '@iconify/react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Iconify from '../components/iconify';

export default function JobDetails ()
{
     const locationData = useLocation();
    const navigate = useNavigate();
     const [row, setRow] = useState(locationData.state?.row || {});




const stripHtmlTags = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };




        return(
         

          <>
          <Stack sx={{p:2.5, mt:6}}>
              <Iconify icon="ion:arrow-back" fontSize={25}
        sx={{ cursor: 'pointer', color: 'text.secondary', fontSize: '0.9rem', fontWeight: '600',
         mb:1.5
         }}
        onClick={() => navigate(-1)} />

       
         <Stack sx={{ border: 2, borderColor: 'text.secondary', borderRadius: 2, p: 2}}>

               <Stack sx={{ flexDirection: { xs: 'column', lg: 'row' },
               width: '100%', mb: 2, gap: 2, justifyContent: 'center' }}
               
                >
                     <Typography sx={{fontWeight: '600', textTransform: 'capitalize', fontSize: '0.9rem' }}
                       color={'text.secondary'}
                     >Job Details</Typography>
                    </Stack>

               <Stack sx={{ border: 2, borderColor: 'text.secondary', borderRadius: 2, p: 2, }}>
            <div id="jobDescPdfDown">
              <Typography sx={{ fontWeight: '600', textTransform: 'capitalize' }}>{row?.companyName
}</Typography>
              <Stack direction={'row'} gap={1} alignItems={'center'}>
                <Typography
                  sx={{ fontWeight: '600', cursor: 'pointer', textTransform: 'capitalize', fontSize: '0.9rem' }}
                  color={'text.secondary'}
                >
                  {row?.jobTitle} - {row?.jobId}
                </Typography>
                <Typography color={'text.textG'} sx={{ textTransform: 'capitalize' }}>
                  [ {row?.altJobTitle?.join(' | ')} ]
                </Typography>
              </Stack>
              <Typography sx={{ textTransform: 'capitalize' }}>
                {row?.openings} Openings : {row?.jobType}
              </Typography>
              <Stack direction={'row'} gap={1} alignItems={'center'}>
                <Typography>Updated : </Typography>
                <Typography sx={{ color: 'text.secondary' }}>{moment(row?.createdAT).format('ll')}</Typography>
              </Stack>
              <Stack direction={{ xs: 'column', lg: "row" }} gap={{ xs: 0, lg: 3 }} alignItems={{ xs: 'flex-start', lg: "center" }}>
                {/* <Typography sx={{ fontWeight: '600', color: 'text.secondary' }}>{row?.location}</Typography> */}
                <Typography sx={{ fontWeight: '600', color: 'text.secondary' }}>{row?.city}{", "}{row?.stateCode}</Typography>
                <Stack direction={'row'} gap={1} alignItems={'center'}>
                  <Typography sx={{ fontWeight: '600' }}>Out Of Area Candidate : </Typography>
                  <Typography sx={{ textTransform: 'capitalize' }}>{row?.outOfAreaCandidate}</Typography>
                </Stack>
                <Stack direction={'row'} gap={1} alignItems={'center'}>
                  <Typography sx={{ fontWeight: '600' }}>Relocation Assistance :</Typography>
                  <Typography sx={{ textTransform: 'capitalize' }}>{row?.relocationAssistance}</Typography>
                </Stack>
                <Stack direction={'row'} gap={1} alignItems={'center'}>
                  <Typography sx={{ fontWeight: '600' }}>Amount :</Typography>
                  <Typography>${row?.relocationExpenses}K</Typography>
                </Stack>
              </Stack>
              <Typography sx={{ textTransform: 'capitalize' }}>{row?.remote}</Typography>
              <Typography sx={{ fontWeight: '600', textTransform: 'capitalize' }}>Compensation</Typography>
              {row?.compensationType === 'annual' && (
                <Typography>
                  ${row?.annualMinCompensation}K - ${row?.annualMaxCompensation}K
                </Typography>
              )}
              {row?.compensationType === 'per hour' && (
                <>
                  <Typography>
                    Pay Rate on  W2 / T4 : ${row?.payRateOn?.minPayRate} P/H - ${row?.payRateOn?.maxPayRate} P/H
                  </Typography>
                  <Typography>
                    Pay Rate on C2C/1099/Inc : ${row?.onC2c1099Inc?.minC2c1099Inc} P/H - ${row?.onC2c1099Inc?.maxC2c1099Inc} P/H
                  </Typography>
                </>
              )}
              {row?.benefits?.length ? (
                <>
                  <Typography sx={{ fontWeight: '600', textTransform: 'capitalize' }}>Benefits</Typography>
                  <Typography sx={{ textTransform: 'capitalize' }}>{row?.benefits}</Typography>
                </>
              ) : null}
              <Typography sx={{ fontWeight: '600', mt: 2 }} color={'text.secondary'}>
                Job Description:
              </Typography>
              {/* <Typography>{row.jobDescription}</Typography> */}
              <div dangerouslySetInnerHTML={{ __html: row?.jobDescription }} />
              {/* <Typography sx={{ fontWeight: '600', mt: 2 }} color={''}>
            Duties/Responsibilities:
          </Typography>
          <Stack sx={{ p: 1 }}>
            <Typography>{row.recruitingInst}</Typography>
          </Stack>
          <Typography sx={{ fontWeight: '600', mt: 2 }} color={''}>
            Required Skills/Abilities::
          </Typography>
          <Stack sx={{ p: 1 }}>
            <Typography>
              Excellent Attention to Detail Excellent written and verbal communication skills. Excellent organizational
              and time management skills. Accounting background. Proficient in Microsoft Office Suite or similar
              software. Strong Excel skills Insurance Agency/Broker accounting Preferred Abilities: Knowledge of Applied
              TAM or EPIC a plus! Education and Experience: Bachelor’s degree in Accounting or Business Administration
              Five years or more of related experience work in accounting on the Broker/Agency Insurance industry in the
              absence of a related degree. Physical Requirements: Prolonged periods sitting at a desk and working on a
              computer.
            </Typography>
          </Stack> */}
              <Typography sx={{ fontWeight: '600', mt: 1 }} color={'text.secondary'}>
                Min/Max Years of Experience
              </Typography>
              <Stack direction="row" gap={2}>
                {row?.minExperience && row?.maxExperience && (
                  <Typography sx={{ textTransform: 'capitalize' }}>
                    Min: {row?.minExperience} to Max: {row?.maxExperience}
                  </Typography>
                )}
              </Stack>

              {row?.skillWithExp?.length > 0 && (
                <Stack>
                  <Typography sx={{ fontWeight: '600' }}>Must Have Skills:</Typography>
                  {row?.skillWithExp.map((item, index) => (
                    <Stack direction="row" gap={2} key={index}>
                      <Typography sx={{ textTransform: 'capitalize' }}>{item.mustHaveSkill}</Typography>
                      <Typography sx={{ textTransform: 'capitalize' }}>{item.minExperience}</Typography>
                    </Stack>
                  ))}
                </Stack>
              )}

              {row?.desiredSkillsWithExp?.length > 0 && (
                <Stack>
                  <Typography sx={{ fontWeight: '600' }}>Desired Skills:</Typography>
                  {row?.desiredSkillsWithExp?.map((item, index) => (
                    <Stack direction="row" gap={2} key={index}>
                      <Typography sx={{ textTransform: 'capitalize' }}>{item?.desiredSkill}</Typography>
                      <Typography sx={{ textTransform: 'capitalize' }}>{item?.minExperience}</Typography>
                    </Stack>
                  ))}
                </Stack>
              )}

              <Typography sx={{ fontWeight: '600', mt: 1 }} color={'text.secondary'}>
                Education:
              </Typography>
              <Stack sx={{}}>
                {row?.degree?.length > 0 && (
                  <Stack>
                    <Typography sx={{ fontWeight: '600', textTransform: 'capitalize' }}>degree</Typography>
                    {row?.degree?.length
                      ? row?.degree?.map((item) => {
                        return (
                          <Stack direction={'row'} gap={2}>
                            <Typography sx={{ textTransform: 'capitalize' }}>{item?.degree}</Typography>
                            <Typography sx={{ textTransform: 'capitalize' }}>{item?.degreeRequired}</Typography>
                          </Stack>
                        );
                      })
                      : null}
                  </Stack>
                )}
                {row?.certifications?.length > 0 && (
                  <Stack>
                    <Typography sx={{ fontWeight: '600', textTransform: 'capitalize', mt: 0.5 }}>certification</Typography>
                    {row?.certifications?.length
                      ? row?.certifications?.map((item) => {
                        return (
                          <Stack direction={'row'} gap={2}>
                            <Typography sx={{ textTransform: 'capitalize' }}>{item?.certification}</Typography>
                            <Typography sx={{ textTransform: 'capitalize' }}>{item?.certificationRequired}</Typography>
                          </Stack>
                        );
                      })
                      : null}
                    {/* <Typography sx={{ textTransform: 'capitalize' }}>
                {row.certifications ? row.certifications : '-'}
              </Typography>
              <Typography sx={{ textTransform: 'capitalize' }}>{row.certificationRequired}</Typography> */}
                  </Stack>
                )}
              </Stack>
              {/* <Stack sx={{ justifyContent: 'center', width: '100%', flexDirection: 'row' }}>
            <CopyToClipboard
              text={`
              ${row.endClientOrImpPartner}
              ${row.jobTitle} - ${row.jobId} [ ${row.altJobTitle.join(', ')} ]
              ${row.openings} Vacancy : ${row.jobType}
              Updated : ${moment(row.createdAT).format('ll')}
              ${row.location}Out Of Area Candidate : ${row.outOfAreaCandidate} Relocation Assistance : ${row.relocationAssistance} Amount : ${row.relocationExpenses}
              ${row.remote}
              Compensation : ${row.compensationType === 'annual' && (
                 `$ ${row.annualMinCompensation} K - $ ${row.annualMaxCompensation} K`
              )} 
              ${row.compensationType === 'per hour' && (
                `$ ${row.payRateOn.minPayRate} P/H - $ ${row.payRateOn.maxPayRate} P/H`
              )}
             
              Job Description: ${stripHtmlTags(row.jobDescription)}
              Minimum Years of Experience:  ${row.minExperience} to ${row.maxExperience}
              Must Have Skills: ${row.skillWithExp.length?row.skillWithExp.map((item, index) =>{
                return `${item.mustHaveSkill} ${item.minExperience}`
              }):null}
              Desired Skills: ${row.desiredSkillsWithExp.length?row.desiredSkillsWithExp.map((item, index) => {
                return `${item.desiredSkill} ${item.minExperience}`
              }):null}
              Education: ${row.degree.length
                ? row.degree.map((item) => {
                    return `${item.degree} ${item.degreeRequired}`
                  }):null}
              Certification:  ${row.certifications.length
                    ? row.certifications.map((item) => {
                        return `${item.certification} ${item.certificationRequired}`
                      }
                    ):null}`}
            >
              <Button variant="contained" size="small" color="custom" sx={{ width: 'fit-content' }}>
                Copy Description
              </Button>
            </CopyToClipboard>
          </Stack> */}

              {/* <Stack sx={{ justifyContent: 'center', width: '100%', flexDirection: 'row' }}>
              <CopyToClipboard
                text={`
      ${row.endClientOrImpPartner || ''}
      ${row.jobTitle} - ${row.jobId} [ ${row.altJobTitle.join(', ')} ]
      ${row.openings ? `${row.openings} Vacancy : ${row.jobType}` : ''}
      Updated : ${moment(row.createdAT).format('ll')}
      ${row.location || ''} Out Of Area Candidate : ${row.outOfAreaCandidate || ''} Relocation Assistance : ${row.relocationAssistance || ''} Amount : ${row.relocationExpenses || ''}
      ${row.remote || ''}
      Compensation : ${row.compensationType === 'annual' ? `$ ${row.annualMinCompensation} K - $ ${row.annualMaxCompensation} K` : ''}
      ${row.compensationType === 'per hour' ? `$ ${row.payRateOn.minPayRate} P/H - $ ${row.payRateOn.maxPayRate} P/H` : ''}
      Job Description: 

      ${stripHtmlTags(row.jobDescription || '')}

      Minimum Years of Experience: ${row.minExperience || ''} to ${row.maxExperience || ''}
      Must Have Skills: ${row.skillWithExp.length ? row.skillWithExp.map((item) => {
                  return `${item.mustHaveSkill} ${item.minExperience}`;
                }).join(', ') : ''}
      Desired Skills: ${row.desiredSkillsWithExp.length ? row.desiredSkillsWithExp.map((item) => {
                  return `${item.desiredSkill} ${item.minExperience}`;
                }).join(', ') : ''}
      Education: ${row.degree.length ? row.degree.map((item) => {
                  return `${item.degree} ${item.degreeRequired}`;
                }).join(', ') : ''}
      Certification: ${row.certifications.length ? row.certifications.map((item) => {
                  return `${item.certification} ${item.certificationRequired}`;
                }).join(', ') : ''}
    `}
                 
              > 
              
              </CopyToClipboard>
            </Stack>
  */}

              <Stack sx={{ justifyContent: 'center', width: '100%', flexDirection: 'row' }}>
                <div id="jobDescPdfDownload">
                  <CopyToClipboard
                    text={`
      ${row?.endClientOrImpPartner || ''}
      ${row?.jobTitle} - ${row?.jobId} [ ${row?.altJobTitle?.join(', ')} ]
      ${row?.openings ? `${row?.openings} Vacancy : ${row?.jobType}` : ''}
      Updated : ${moment(row?.createdAT)?.format('ll')}
      ${row?.location || ''} Out Of Area Candidate : ${row?.outOfAreaCandidate || ''} Relocation Assistance : ${row?.relocationAssistance || ''} Amount : ${row?.relocationExpenses || ''}
      ${row?.remote || ''}
      Compensation : ${row?.compensationType === 'annual' ? `$ ${row?.annualMinCompensation} K - $ ${row?.annualMaxCompensation} K` : ''}
      ${row.compensationType === 'per hour' ? `$ ${row?.payRateOn.minPayRate} P/H - $ ${row?.payRateOn.maxPayRate} P/H` : ''}
      Job Description: 

      ${stripHtmlTags(row?.jobDescription || '')}

      Minimum Years of Experience: ${row?.minExperience || ''} to ${row?.maxExperience || ''}
      Must Have Skills: ${row?.skillWithExp?.length ? row?.skillWithExp?.map((item) => {
                      return `${item?.mustHaveSkill} ${item?.minExperience}`;
                    }).join(', ') : ''}
      Desired Skills: ${row?.desiredSkillsWithExp?.length ? row?.desiredSkillsWithExp?.map((item) => {
                      return `${item?.desiredSkill} ${item?.minExperience}`;
                    }).join(', ') : ''}
      Education: ${row?.degree?.length ? row?.degree?.map((item) => {
                      return `${item?.degree} ${item?.degreeRequired}`;
                    }).join(', ') : ''}
      Certification: ${row?.certifications?.length ? row?.certifications?.map((item) => {
                      return `${item?.certification} ${item?.certificationRequired}`;
                    }).join(', ') : ''}
    `}
                  >
                    <span />
                  </CopyToClipboard>
                </div>

              </Stack>
              {/* <button onClick={() => handleDownloadFromClipboard()}>Download PDF</button> */}
            </div>
               </Stack>
         </Stack>
          </Stack>
          
            </>
        )
}